
import {
    BPM_PRODUCT,
    BPM_PRODUCT_SUCCESS,
    BPM_PRODUCT_ERROR,
    BPM_SUPPLIER,
    BPM_SUPPLIER_SUCCESS,
    BPM_SUPPLIER_ERROR,
    BPM_CATEGORY,
    BPM_CATEGORY_SUCCESS,
    BPM_CATEGORY_ERROR,
    BPM_COUNTRY,
    BPM_COUNTRY_SUCCESS,
    BPM_COUNTRY_ERROR,
    BPM_LIST,
    BPM_LIST_SUCCESS,
    BPM_LIST_ERROR,
    BPM_LIST_SEARCH_CHANGE,
    BPM_LIST_PAGE_SET,
    BPM_ADD_MODAL_SET,
    BPM_ADD_CHANGE_SET,
    BPM_ADD,
    BPM_ADD_SUCCESS,
    BPM_ADD_ERROR,
    BPM_EDIT_MODAL_SET,
    BPM_EDIT_CHANGE_SET,
    BPM_EDIT,
    BPM_EDIT_SUCCESS,
    BPM_EDIT_ERROR,
    BPM_UPLOAD_SET,
    BPM_UPLOAD_SET_SUCCESS,
    BPM_UPLOAD_SET_ERROR,
    BPM_UPLOAD_RESET,
    BPM_UPLOAD2_SET,
    BPM_UPLOAD2_SET_SUCCESS,
    BPM_UPLOAD2_SET_ERROR,
    BPM_UPLOAD2_RESET
} from "../../actions";

const INIT_STATE = {
    loading: false,
    list: {
        page: {
            current: 1,
            rows: 10
        }
    },
    product: {
        loading: false,
        data: []
    },
    supplier: {
        loading: false,
        data: []
    },
    category: {
        loading: false,
        data: []
    },
    country: {
        loading: false,
        data: []
    },
    add: {
        data: [],
        modal: false,
        loading: false,
        message: '',
        url: '',
        type: ''
    },
    edit: {
        data: [],
        modal: false,
        loading: false,
        message: '',
        url: '',
        type: ''
    },
    file: [],
    files: [],
    error: false,
    search: {
        modal: false,
        init: true,
        data: {
            product: '',
            supplier: '',
            status: '',
            category:''
        },
        value: {
            product: '',
            supplier: '',
            status: '',
            category:''
        }
    }
};


export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case BPM_PRODUCT:
            return {
                ...state,
                loading: true,
                product: {
                    ...state.product
                }
            }
        case BPM_PRODUCT_SUCCESS:
            return {
                ...state,
                loading: false,
                product: {
                    ...state.product,
                    ...action.payload
                }
            }
        case BPM_PRODUCT_ERROR:
            return {
                ...state,
                loading: false,
                error: true
            }
        case BPM_SUPPLIER:
            return {
                ...state,
                loading: true,
                supplier: {
                    ...state.supplier
                }
            }
        case BPM_SUPPLIER_SUCCESS:
            return {
                ...state,
                loading: false,
                supplier: {
                    ...state.supplier,
                    ...action.payload
                }
            }
        case BPM_SUPPLIER_ERROR:
            return {
                ...state,
                loading: false,
                error: true
            }
        case BPM_CATEGORY:
            return {
                ...state,
                loading: true,
                category: {
                    ...state.category
                }
            }
        case BPM_CATEGORY_SUCCESS:
            return {
                ...state,
                loading: false,
                category: {
                    ...state.category,
                    ...action.payload
                }
            }
        case BPM_CATEGORY_ERROR:
            return {
                ...state,
                loading: false,
                error: true
            }
        case BPM_COUNTRY:
            return {
                ...state,
                loading: true,
                country: {
                    ...state.country
                }
            }
        case BPM_COUNTRY_SUCCESS:
            return {
                ...state,
                loading: false,
                country: {
                    ...state.country,
                    ...action.payload
                }
            }
        case BPM_COUNTRY_ERROR:
            return {
                ...state,
                loading: false,
                error: true
            }
        case BPM_LIST:
            return {
                ...state,
                loading: true,
                list: {
                    ...state.list
                }
            }

        case BPM_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                list: {
                    ...state.list,
                    ...action.payload
                }
            }
        case BPM_LIST_ERROR:
            return {
                ...state,
                loading: false,
                error: true
            }

        case BPM_LIST_PAGE_SET:
            return {
                ...state,
                list: {
                    ...state.list,
                    page: {
                        ...state.list.page,
                        ...action.payload,
                    }
                }
            }
        case BPM_LIST_SEARCH_CHANGE:
            return {
                ...state,
                search: {
                    ...state.search,
                    data: action.payload,
                }
            }
        case BPM_ADD_MODAL_SET:
            return {
                ...state,
                add: {
                    ...state.add,
                    modal: action.payload
                }
            }
        case BPM_ADD_CHANGE_SET:
            return {
                ...state,
                add: {
                    ...state.add,
                    data: {
                        ...state.add.data,
                        ...action.payload
                    }
                }
            }
        case BPM_ADD:
            return {
                ...state,
                add: {
                    ...state.add,
                    loading: false
                }
            }
        case BPM_ADD_SUCCESS:
            return {
                ...state,
                add: {
                    ...state.add,
                    modal: false,
                    loading: false,
                    url: action.payload.url,
                    type: action.payload.type,
                    message: action.payload.message
                },
                list: {
                    ...state.list,
                    ...action.payload
                }
            }
        case BPM_ADD_ERROR:
            return {
                ...state,
                add: {
                    ...state.add,
                    loading: false,
                    type: action.payload.type,
                    message: action.payload.message
                }
            }
        case BPM_EDIT_MODAL_SET:
            return {
                ...state,
                edit: {
                    ...state.edit,
                    modal: action.payload
                }
            }
        case BPM_EDIT_CHANGE_SET:
            return {
                ...state,
                edit: {
                    ...state.edit,
                    data: {
                        ...state.edit.data,
                        ...action.payload
                    }
                }
            }
        case BPM_EDIT:
            return {
                ...state,
                edit: {
                    ...state.edit,
                    loading: false
                }
            }
        case BPM_EDIT_SUCCESS:
            return {
                ...state,
                edit: {
                    ...state.edit,
                    modal: false,
                    loading: false,
                    url: action.payload.url,
                    type: action.payload.type,
                    message: action.payload.message
                },
                list: {
                    ...state.list,
                    ...action.payload
                }
            }
        case BPM_EDIT_ERROR:
            return {
                ...state,
                edit: {
                    ...state.edit,
                    loading: false,
                    type: action.payload.type,
                    message: action.payload.message
                }
            }
        case BPM_UPLOAD_SET:
            return { ...state };

        case BPM_UPLOAD_SET_SUCCESS:
            return {
                ...state,
                file: { ...state.file, ...action.payload }
            };

        case BPM_UPLOAD_SET_ERROR:
            return {
                ...state,
                file: { ...state.file, ...action.payload }
            };

        case BPM_UPLOAD_RESET:
            return {
                ...state,
                file: []
            };
        case BPM_UPLOAD2_SET:
            return { ...state };

        case BPM_UPLOAD2_SET_SUCCESS:
            return {
                ...state,
                files: { ...state.files, ...action.payload }
            };

        case BPM_UPLOAD2_SET_ERROR:
            return {
                ...state,
                files: { ...state.files, ...action.payload }
            };

        case BPM_UPLOAD2_RESET:
            return {
                ...state,
                files: []
            };

        default:
            return { ...state };
    }
};